var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldType, } from "@brushfire/types";
import { useState, useEffect, useContext } from "react";
import { useDispatch } from "react-redux";
import { getAttendeeForm, putAttendeeForm } from "../../../data/api";
import { convertToFieldViews, handleErrors, isVisible } from "../../../data/helpers";
import { useIntl } from "react-intl";
import { setFormIsSubmitting } from "../../../store/AppState/actions";
import { AppFormContext } from "../../../App";
import CartQuestionForm from "../Register/Steps/Cart/CartQuestionForm";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
import Constants from "../../../data/constants";
import WidgetSticky from "../../Helpers/WidgetSticky";
import { Col, Row } from "@brushfire/ui";
import Skeleton from "@material-ui/lab/Skeleton";
import { setPaymentRequiredPayload } from "../../../store/PostAttendeeActions/actions";
import { PaymentPayloadType } from "../../../store/PostAttendeeActions/types";
import NoChangesAfterMessage from "./NoChangesAfterMessage";
import useFormatters from "../../../hooks/useFormatters";
var MyAttendeeEdit = function (_a) {
    var eventData = _a.eventData, attendee = _a.attendee, path = _a.path, isMobile = _a.isMobile, setSuccessMessage = _a.setSuccessMessage, refreshAttendeeList = _a.refreshAttendeeList, group = _a.group, order = _a.order;
    var _b = __read(useState(), 2), attendeeForm = _b[0], setAttendeeForm = _b[1];
    var _c = __read(useState(false), 2), isSaving = _c[0], setIsSaving = _c[1];
    var _d = __read(useState(false), 2), isLoading = _d[0], setIsLoading = _d[1];
    var _e = __read(useState(false), 2), hideAlert = _e[0], setHideAlert = _e[1];
    var dispatch = useDispatch();
    var formikContext = useContext(AppFormContext).formikContext;
    var intl = useIntl();
    var history = useWidgetHistory();
    var formatCurrency = useFormatters().formatCurrency;
    useEffect(function () {
        if ((attendee === null || attendee === void 0 ? void 0 : attendee.id) && [Constants.Routes.myAttendeeEdit].includes(path)) {
            setIsLoading(true);
            getAttendeeForm(attendee === null || attendee === void 0 ? void 0 : attendee.id)
                .then(function (_a) {
                var data = _a.data;
                setAttendeeForm(data);
            })
                .catch(function (err) {
                handleErrors(err, dispatch);
            })
                .finally(function () {
                setIsLoading(false);
            });
        }
        setHideAlert(false);
    }, [attendee === null || attendee === void 0 ? void 0 : attendee.id, path]);
    var hasPricedFields = attendeeForm === null || attendeeForm === void 0 ? void 0 : attendeeForm.fields.some(function (o) { return o.options.some(function (p) { var _a; return ((_a = p === null || p === void 0 ? void 0 : p.unitPrice) !== null && _a !== void 0 ? _a : 0) > 0; }); });
    var submitQuestions = function (values, formikHelpers, setGlobalError) {
        var _a, _b;
        var cleanedValues = Object.assign({}, values);
        (_a = Object.keys(cleanedValues)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
            var _a, _b, _c, _d;
            if (key === "isGift" || key === "recipientEmail" || key === "isPreRegistered" || key === "copyToAll") {
                delete cleanedValues[key];
            }
            else {
                if (Array.isArray(cleanedValues[key])) {
                    cleanedValues[key] = cleanedValues[key].filter(function (x) { return !!x; });
                    if (cleanedValues[key].some(function (x) { return !!x.price; })) {
                        var v = intl.formatNumberToParts(1000.0, {
                            style: "currency",
                            currency: (_a = eventData.currency) !== null && _a !== void 0 ? _a : "USD",
                        });
                        var symbol_1 = ((_b = v.find(function (x) { return x.type === "currency"; })) === null || _b === void 0 ? void 0 : _b.value) || "$";
                        var isCommaDecimal_1 = ((_c = v.find(function (x) { return x.type === "decimal"; })) === null || _c === void 0 ? void 0 : _c.value) === ",";
                        (_d = cleanedValues[key]) === null || _d === void 0 ? void 0 : _d.forEach(function (opt) {
                            var _a, _b;
                            if (isNaN(opt.price)) {
                                opt.price = opt.price
                                    ? opt.price === ""
                                        ? 0
                                        : isCommaDecimal_1
                                            ? parseFloat(((_a = opt.price) === null || _a === void 0 ? void 0 : _a.replace(/\s+/g, "").replace(",", ".").replace(symbol_1 || "$", "")) || "0.00")
                                            : parseFloat(((_b = opt.price) === null || _b === void 0 ? void 0 : _b.replace(/\s+/g, "").replace(symbol_1 || "$", "")) || "0.00")
                                    : 0;
                            }
                        });
                    }
                }
            }
        });
        if (attendee === null || attendee === void 0 ? void 0 : attendee.id) {
            dispatch(setFormIsSubmitting(true));
            setIsSaving(true);
            var fieldViews_1 = convertToFieldViews((_b = attendeeForm === null || attendeeForm === void 0 ? void 0 : attendeeForm.fields) !== null && _b !== void 0 ? _b : []);
            Object.keys(cleanedValues).forEach(function (id) {
                var field = fieldViews_1.find(function (field) { return field.id === id || field.childFields.some(function (child) { return child.id === id; }); });
                if (!field ||
                    !isVisible(field, values, fieldViews_1) ||
                    [
                        FieldType[FieldType.Paragraph],
                        FieldType[FieldType.SectionHeader],
                        FieldType[FieldType.Link],
                    ].includes(field.type)) {
                    delete cleanedValues[id];
                }
            });
            var payload_1 = {
                fields: Object.keys(cleanedValues).map(function (key) { return ({ id: key, value: cleanedValues[key] }); }),
            };
            putAttendeeForm(attendee === null || attendee === void 0 ? void 0 : attendee.id, payload_1)
                .then(function (res) {
                var _a, _b;
                if (res.status === 202) {
                    dispatch(setPaymentRequiredPayload({
                        type: PaymentPayloadType.attendeeFormUpdate,
                        payload: res.data,
                        originalFields: payload_1,
                        summaryText: "You're about to make a change to your attendee info resulting in a".concat(res.data.total > 0 ? "n additional charge of " : " refund of ").concat(formatCurrency(res.data.total)),
                    }));
                }
                else {
                    setSuccessMessage("Attendee Saved");
                    refreshAttendeeList();
                    formikHelpers.resetForm({ values: values });
                    history.push(Constants.Routes.myAttendee
                        .replace(":clientKey", eventData.clientKey)
                        .replace(":urlKey", eventData.urlKey)
                        .replace(Constants.Regex.guid, "")
                        .replace(":attendeeId", attendee.id)
                        .replace(":orderKey", (_a = order === null || order === void 0 ? void 0 : order.orderKey) !== null && _a !== void 0 ? _a : "")
                        .replace(":groupNumber", (_b = group === null || group === void 0 ? void 0 : group.groupNumber.toString()) !== null && _b !== void 0 ? _b : "")
                        .replace(":eventNumber", eventData.eventNumber.toString()));
                }
            })
                .catch(function (err) {
                if (formikContext) {
                    handleErrors(err, dispatch, formikContext, setGlobalError);
                }
                setHideAlert(true);
            })
                .finally(function () {
                setTimeout(function () {
                    setIsSaving(false);
                    formikHelpers.setSubmitting(false);
                    dispatch(setFormIsSubmitting(false));
                }, 500);
            });
        }
    };
    if (!attendeeForm || isLoading) {
        return (_jsxs(WidgetSticky, __assign({ className: "sticky-form", bottomOffset: 75, topOffset: 10, active: true }, { children: [_jsxs(Row, { children: [_jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "35%" }) })), _jsx(Col, __assign({ xs: 6 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })), _jsx(Col, __assign({ xs: 6 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }), _jsxs(Row, __assign({ className: "m-top-large" }, { children: [_jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "25%" }) })), _jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }))] })));
    }
    return (_jsxs("div", { children: [(hasPricedFields || (attendee === null || attendee === void 0 ? void 0 : attendee.changesAreBlocked) || (attendee === null || attendee === void 0 ? void 0 : attendee.hasUnpaidInvoice)) && (_jsx(NoChangesAfterMessage, { changesAreBlocked: attendee === null || attendee === void 0 ? void 0 : attendee.changesAreBlocked, changesAreBlockedAfter: attendee === null || attendee === void 0 ? void 0 : attendee.changesAreBlockedAfter, attendeeChange: eventData.attendeeChanges, hasUnpaidInvoice: attendee === null || attendee === void 0 ? void 0 : attendee.hasUnpaidInvoice, hideAlert: hideAlert })), _jsx(CartQuestionForm, { form: attendeeForm, path: path, active: true, submitQuestions: submitQuestions, isSaving: isSaving, isDisabled: (attendee === null || attendee === void 0 ? void 0 : attendee.status) === "Cancelled" || (attendee === null || attendee === void 0 ? void 0 : attendee.changesAreBlocked), currency: eventData.currency, isMobile: isMobile })] }));
};
export default MyAttendeeEdit;
